import axios from 'axios';
import {api} from '../../constants/api';
import {actions as A} from '../../constants/actions';
import {grids} from '../../../../common/constants/grids';

const step9UpdateColumnDisplay = tableType => ({shumaId, columnName, display}) => dispatch => {
  const data = {
    shumaID: parseInt(shumaId, 10),
    tableType: parseInt(tableType, 10),
    columnName,
    display: parseInt(display, 10),
  };

  dispatch({
    type: A.UPDATE_STEP_9_GRID_SAVED_COLUMN,
    payload: {
      id: grids[data.tableType],
      column: data.columnName,
      value: Boolean(data.display)
    }
  });

  return axios.post(api.SAVE_STEP_9_COLUMN_DISPLAY, data)
    .catch(console.error);
};

export const step9ChangeTab1ColumnVisibility = step9UpdateColumnDisplay(5);
export const step9ChangeTab2ColumnVisibility = step9UpdateColumnDisplay(2);
export const step9ChangeTab3ColumnVisibility = step9UpdateColumnDisplay(3);
export const step9ChangeTab4ColumnVisibility = step9UpdateColumnDisplay(4);
